
import AppIntro from "Pages/Profile/AppIntro";
import React from "react";





export default function DashappIntrotheme() {
  return (
    <>
       <AppIntro/>
    </>
  );
}
